<script setup>
const { locale, t } = useI18n()

const search = ref(null)
const term = ref('')
const termToDisplay = ref('')
const results = ref([])
const loading = ref(false)

const handlerSearch = async () => {
  loading.value = true
  termToDisplay.value = term.value

  const searchQuery = `https://be.avu.cz/wp-json/wp/v2/search?search=${encodeURIComponent(term.value)}&lang=${locale.value}`

  try {
    const response = await fetch(searchQuery)
    const data = await response.json()

    setTimeout(() => {
      results.value = data
      loading.value = false
    }, 100)
  } catch (err) {
    console.error(err)
    loading.value = false
  }
}

onMounted(() => {
  search.value?.focus?.()
})
</script>

<template>
  <div>
    <label for="search" class="search">
      <input
        id="search"
        ref="search"
        v-model="term"
        autocomplete="off"
        class="search__input"
        type="text"
        :placeholder="t('search.placeholder')"
        @keyup.enter="handlerSearch"
      />
      <button
        class="lupa"
        tabindex="0"
        aria-label="Search"
        style="background-color: inherit"
        @click="handlerSearch"
      >
        <div class="lupa__inner"></div>
      </button>
      <div v-if="loading" class="search__loader">
        <Loader />
      </div>
    </label>

    <Transition name="fade">
      <div v-if="results && results.length && !loading" class="results">
        <p class="results__title text_minor_3 is_c3">
          {{ t('search.results') }}
          <span class="text_minor_3 is_c2">{{ termToDisplay }}</span>
        </p>
        <div v-for="result in results" :key="result.id" class="text_main is_c3">
          <SearchResult :title="result.title" :url="result.url" />
        </div>
      </div>

      <div v-else-if="!results.length && !loading && termToDisplay.length">
        <p class="results__title text_minor_3">
          {{ t('search.noresults.1') }}
          <span class="text_minor_3 is_c2">{{ termToDisplay }}</span>
          {{ t('search.noresults.2') }}
        </p>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.search {
  margin: 90px auto 110px auto;

  @include media-breakpoint-up(sm) {
    width: 62.014vw;
    margin-right: 0;
  }
  @include media-breakpoint-up(lg) {
    max-width: 1033px;
  }

  &__input {
    font-size: 14px;
  }
}

.results {
  margin-bottom: 90px;

  &__title {
    margin-bottom: 40px;
  }

  @include media-breakpoint-up(sm) {
    width: 62.014vw;
    margin-left: auto;
  }
  @include media-breakpoint-up(lg) {
    max-width: 1033px;
  }
}
</style>
